import { render } from "./RankDialog.vue?vue&type=template&id=ab1abfe0&scoped=true"
import script from "./RankDialog.vue?vue&type=script&lang=js"
export * from "./RankDialog.vue?vue&type=script&lang=js"

import "./RankDialog.vue?vue&type=style&index=0&id=ab1abfe0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab1abfe0"]])

export default __exports__